export const MOCK_AUTH_TOKEN = 'mock-token';

function isEnabled(value: unknown): boolean {
  return value === 'true';
}

export function isE2EMode(): boolean {
  return isEnabled(import.meta.env.VITE_E2E_MODE);
}

export function isMockAuthClientEnabled(): boolean {
  return isEnabled(import.meta.env.VITE_ENABLE_MOCK_AUTH_CLIENT);
}

export function shouldSeedMockAuthToken(): boolean {
  return isMockAuthClientEnabled();
}

export function isMockAuthToken(token: string | null | undefined): boolean {
  return token === MOCK_AUTH_TOKEN;
}

export function isAuthLikeToken(token: string | null | undefined): boolean {
  if (!token) return false;
  if (isMockAuthToken(token)) return isMockAuthClientEnabled();
  return true;
}
